import { useQuery } from '@tanstack/react-query';
import { AxiosResponseHeaders } from 'axios';
import { API } from 'network/api';
import { InvoiceList } from 'screens/collections/invoice/types';

interface UseInvoicesQueryProps {
  params: {
    pbId?: string;
    fgId?: string;
  } & Record<string, string | number>;
  enabled: boolean;
}

const fetchInvoices = async (params: UseInvoicesQueryProps['params']) => {
  try {
    const res = await API.get('/invoices', {
      params,
    });
    const headers = res.headers as AxiosResponseHeaders;

    const totalCount =
      (headers.has('X-Total-Count') && headers?.get('X-Total-Count')) || 0;

    return {
      data: res.data as InvoiceList,
      totalCount: Number(totalCount),
    };
  } catch (err: Error | unknown) {
    if (err instanceof Error) throw err;
    throw new Error('Something went wrong');
  }
};

const useInvoicesQuery = ({ params, enabled }: UseInvoicesQueryProps) => {
  const {
    data: res,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['invoices', params],
    queryFn: () => fetchInvoices(params),
    staleTime: 1000 * 10,
    enabled,
  });

  const totalCount = res?.totalCount || 0;
  const data = res?.data || [];

  return {
    data,
    totalCount,
    isLoading,
    error,
  };
};

export default useInvoicesQuery;
